/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  FileDTO,
  HTTPValidationError,
  PaperFormat,
  PaperOrientation,
  PlanTemplateTypeDTO,
} from '../fastAPI.schemas'

/**
 * Return the plan template of the plan configuration rendered to an image,
creating and storing it (under the plan template images file root) when the
project has none yet. Idempotent: repeated calls answer with the same file
until the organisation's custom template for the configuration changes.
 * @summary Ensure Plan Template Image
 */
export const ensurePlanTemplateImage = (
  projectGuid: string,
  planType: PlanTemplateTypeDTO,
  paperFormat: PaperFormat,
  orientation: PaperOrientation,
) => {
  return customInstance<FileDTO>({
    url: `/projects/${projectGuid}/plan-template-images/${planType}/${paperFormat}/${orientation}`,
    method: 'PUT',
  })
}

export const useEnsurePlanTemplateImageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensurePlanTemplateImage>>,
    TError,
    {
      projectGuid: string
      planType: PlanTemplateTypeDTO
      paperFormat: PaperFormat
      orientation: PaperOrientation
    },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof ensurePlanTemplateImage>>,
  TError,
  {
    projectGuid: string
    planType: PlanTemplateTypeDTO
    paperFormat: PaperFormat
    orientation: PaperOrientation
  },
  TContext
> => {
  const mutationKey = ['ensurePlanTemplateImage']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ensurePlanTemplateImage>>,
    {
      projectGuid: string
      planType: PlanTemplateTypeDTO
      paperFormat: PaperFormat
      orientation: PaperOrientation
    }
  > = props => {
    const { projectGuid, planType, paperFormat, orientation } = props ?? {}

    return ensurePlanTemplateImage(projectGuid, planType, paperFormat, orientation)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/plan-template-images/{planType}/{paperFormat}/{orientation}` },
    {
      operationId:
        'ensure_plan_template_image_projects__project_guid__plan_template_images__plan_type___paper_format___orientation__put',
      operationName: 'ensurePlanTemplateImage',
    },
  )

  return customOptions
}

export type EnsurePlanTemplateImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof ensurePlanTemplateImage>>
>

export type EnsurePlanTemplateImageMutationError = HTTPValidationError

/**
 * @summary Ensure Plan Template Image
 */
export const useEnsurePlanTemplateImage = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensurePlanTemplateImage>>,
    TError,
    {
      projectGuid: string
      planType: PlanTemplateTypeDTO
      paperFormat: PaperFormat
      orientation: PaperOrientation
    },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof ensurePlanTemplateImage>>,
  TError,
  {
    projectGuid: string
    planType: PlanTemplateTypeDTO
    paperFormat: PaperFormat
    orientation: PaperOrientation
  },
  TContext
> => {
  const mutationOptions = useEnsurePlanTemplateImageMutationOptions(options)

  return useMutation(mutationOptions)
}
